(function () {
  const ROOT_CLASS = 'desktop-chart-interactive';
  const FULLSCREEN_CLASS = 'chart-fullscreen';
  const TRISTATE_CLASS = 'tri-state';
  const MODE_ROTATE_CLASS = 'mode-rotate';
  const MODE_MOVE_CLASS = 'mode-move';
  const WIDE_LAYOUT_MIN_WIDTH = 1100;

  // Selected state for standard charts (null, 'rotate', 'move')
  let selectedMode = null; 
  // Selected state for MarketMap on mobile portrait
  let mmapMoveSelected = false; 

  let fullscreenForced = false;
  let isCoarsePointer = false;
  let container = null;
  let mmContainer = null;
  let lastIsPortrait = null;
  let wasFullscreen = false;

  function isCoarsePointerDevice() {
    return window.matchMedia('(any-pointer: coarse)').matches ||
      window.matchMedia('(pointer: coarse)').matches ||
      navigator.maxTouchPoints > 0;
  }

  function isPortraitMobile() {
    const root = document.documentElement;
    if (!root.classList.contains('desktop-portrait-accepted')) {
      return false;
    }
    const portrait = window.matchMedia
      ? window.matchMedia('(orientation: portrait)').matches
      : window.innerHeight >= window.innerWidth;
    return portrait && window.innerWidth < WIDE_LAYOUT_MIN_WIDTH;
  }

  function isMarketMap() {
    return document.body.classList.contains('mmap-graph');
  }

  function isNewsGraph() {
    return document.body.classList.contains('news-graph-active');
  }

  function isMainChartFullscreen() {
    return document.body.classList.contains(FULLSCREEN_CLASS);
  }

  function isLandscapeTouchLayout() {
    return document.documentElement.classList.contains('desktop-landscape');
  }

  function isSwitcherVisible() {
    if (isMarketMap()) return false;
    if (isNewsGraph()) return isCoarsePointer;
    return isCoarsePointer;
  }

  function isMmSwitcherVisible() {
    if (!isMarketMap()) return false;
    return isCoarsePointer && isPortraitMobile();
  }

  function isEffectivelyEnabled() {
    if (!isCoarsePointer) {
      return true;
    }
    if (isMainChartFullscreen()) {
      return true;
    }
    
    if (isMarketMap()) {
       if (isMmSwitcherVisible()) {
           return mmapMoveSelected;
       }
       if (isLandscapeTouchLayout()) return true;
       return true;
    } else {
       if (isSwitcherVisible()) {
           if (isLandscapeTouchLayout()) return true;
           return selectedMode !== null;
       }
       return true;
    }
  }

  function getMainAction() {
    if (isMarketMap()) {
       return mmapMoveSelected ? 'move' : 'rotate';
    }
    return selectedMode === 'move' ? 'move' : 'rotate';
  }

  function syncDomState() {
    const root = document.documentElement;
    root.classList.toggle(ROOT_CLASS, isEffectivelyEnabled() && isCoarsePointer);

    if (container) {
      const visible = isSwitcherVisible();
      const isPortrait = isPortraitMobile();
      
      const isPortraitChanged = lastIsPortrait !== isPortrait;
      lastIsPortrait = isPortrait;
      
      if (isPortraitChanged && isPortrait) {
          selectedMode = null;
      }
      
      container.classList.toggle('show', visible);
      container.classList.toggle('force-hide', !visible);
      
      if (visible) {
          container.classList.toggle(TRISTATE_CLASS, isPortrait);
          
          if (!isPortrait && selectedMode === null) {
              selectedMode = 'rotate';
          }
          
          container.classList.toggle(MODE_ROTATE_CLASS, selectedMode === 'rotate');
          container.classList.toggle(MODE_MOVE_CLASS, selectedMode === 'move');
      }
    }
    
    if (mmContainer) {
      const mmVisible = isMmSwitcherVisible();
      mmContainer.classList.toggle('show', mmVisible);
      mmContainer.classList.toggle('force-hide', !mmVisible);
      
      if (mmVisible) {
          mmContainer.classList.toggle(MODE_MOVE_CLASS, mmapMoveSelected);
      }
    }

    window.StockStorm3DInteraction?.setMainAction?.(getMainAction());
  }

  function selectMode(mode) {
    if (!isSwitcherVisible()) return;
    
    if (isPortraitMobile()) {
        selectedMode = selectedMode === mode ? null : mode;
    } else {
        selectedMode = mode;
    }
    
    if (selectedMode === null) {
      window.StockStorm3DInteraction?.resetGestureState?.();
    }
    syncDomState();
  }
  
  function toggleMmMode() {
      if (!isMmSwitcherVisible()) return;
      mmapMoveSelected = !mmapMoveSelected;
      if (!mmapMoveSelected) {
          window.StockStorm3DInteraction?.resetGestureState?.();
      }
      syncDomState();
  }

  function handleFullscreenChange() {
    if (!isCoarsePointer) return;
    
    const isFullscreen = isMainChartFullscreen();
    if (isFullscreen === wasFullscreen) return;
    wasFullscreen = isFullscreen;
    
    if (isFullscreen) {
      fullscreenForced = true;
    } else {
      fullscreenForced = false;
      if (isPortraitMobile()) {
          selectedMode = null;
      }
      mmapMoveSelected = false;
      window.StockStorm3DInteraction?.resetGestureState?.();
    }
  }

  function init() {
    if (window.AppState && (window.AppState.isTrueVRMode && !window.AppState.isMobileDevice)) return;
    isCoarsePointer = isCoarsePointerDevice();
    selectedMode = isPortraitMobile() ? null : 'rotate';
    mmapMoveSelected = false;
    fullscreenForced = false;

    window.StockStorm3DInteraction = window.StockStorm3DInteraction || {};
    window.StockStorm3DInteraction.isEnabled = isEffectivelyEnabled;
    window.StockStorm3DInteraction.getMainAction = getMainAction;

    container = document.querySelector('#main-block .chart-wrapper .rotate-move-switcher-container:not(.marketmap-move-zoom-switcher-container)');
    if (container && isCoarsePointer) {
      const rotateBtn = container.querySelector('.item-rotate');
      const moveBtn = container.querySelector('.item-move');

      if (rotateBtn) {
        rotateBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMode('rotate');
        });
      }
      if (moveBtn) {
        moveBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMode('move');
        });
      }
    }
    
    mmContainer = document.querySelector('#main-block .chart-wrapper .marketmap-move-zoom-switcher-container');
    if (mmContainer && isCoarsePointer) {
        const moveBtn = mmContainer.querySelector('.item-move');
        if (moveBtn) {
            moveBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleMmMode();
            });
        }
    }

    const observer = new MutationObserver((mutations) => {
        handleFullscreenChange();
        syncDomState();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    syncDomState();
    window.addEventListener('resize', syncDomState);
    window.addEventListener('orientationchange', syncDomState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
